export const statusData = [
    {
        id: 1,
        mmsi: '000001',
        name: 'vessel1',
        oilCode: '000001',
        implementDate: '09/10/2564',
        status: 'แจ้งยืนยันการลงทะเบียนเรือ',
    },
    {
        id: 2,
        mmsi: '000002',
        name: 'vessel2',
        oilCode: '000002',
        implementDate: '09/10/2564',
        status: 'แจ้งยืนยันการลงทะเบียนเรือ',
    },
    {
        id: 3,
        mmsi: '000003',
        name: 'vessel3',
        oilCode: '000003',
        implementDate: '09/10/2564',
        status: 'แจ้งยืนยันการลงทะเบียนเรือ',
    },
    {
        id: 4,
        mmsi: '000004',
        name: 'vessel4',
        oilCode: '000004',
        implementDate: '09/10/2564',
        status: 'แจ้งยืนยันการลงทะเบียนเรือ',
    },
    {
        id: 5,
        mmsi: '000005',
        name: 'vessel5',
        oilCode: '000005',
        implementDate: '09/10/2564',
        status: 'แจ้งยืนยันการลงทะเบียนเรือ',
    },
    {
        id: 6,
        mmsi: '000006',
        name: 'vessel6',
        oilCode: '000006',
        implementDate: '09/10/2564',
        status: 'แจ้งซ่อมอุปกรณ์',
    },
    {
        id: 7,
        mmsi: '000007',
        name: 'vessel7',
        oilCode: '000007',
        implementDate: '09/10/2564',
        status: 'แจ้งซ่อมอุปกรณ์',
    }, 
    {
        id: 8,
        mmsi: '000008',
        name: 'vessel8',
        oilCode: '000008',
        implementDate: '09/10/2564',
        status: 'แจ้งซ่อมอุปกรณ์',
    },
    {
        id: 9,
        mmsi: '000009',
        name: 'vessel9',
        oilCode: '000009',
        implementDate: '09/10/2564',
        status: 'แจ้งซ่อมอุปกรณ์',
    },
    {
        id: 10,
        mmsi: '0000010',
        name: 'vessel10',
        oilCode: '0000010',
        implementDate: '09/10/2564',
        status: 'แจ้งซ่อมอุปกรณ์',
    },
    {
        id: 11,
        mmsi: '0000011',
        name: 'vessel11',
        oilCode: '0000011',
        implementDate: '09/10/2564',
        status: 'แจ้งออกจากโครงการ',
    },
    {
        id: 12,
        mmsi: '0000012',
        name: 'vessel12',
        oilCode: '0000012',
        implementDate: '09/10/2564',
        status: 'แจ้งออกจากโครงการ',
    },
    {
        id: 13,
        mmsi: '0000013',
        name: 'vessel13',
        oilCode: '0000013',
        implementDate: '09/10/2564',
        status: 'แจ้งออกจากโครงการ',
    },
    {
        id: 14,
        mmsi: '0000014',
        name: 'vessel14',
        oilCode: '0000014',
        implementDate: '09/10/2564',
        status: 'แจ้งออกจากโครงการ',
    },
    {
        id: 15,
        mmsi: '0000015',
        name: 'vessel15',
        oilCode: '0000015',
        implementDate: '09/10/2564',
        status: 'แจ้งออกจากโครงการ',
    },

    
]